import React from "react";

function WarningIcon (props) {
    const { idAttribute, fill, classname, click } = props;

    return (
		<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill={ fill } id={ idAttribute } className={ classname } onClick={ click !== undefined ? click : null }>
			<path d="m12 2.0012136c-5.509058 0-10 4.4895401-10 9.9989738 0 5.5094137 4.490942 9.9985991 10 9.9985991s10-4.4891853 10-9.9985991c0-5.5094337-4.490942-9.9989738-10-9.9989738zm0 14.9982638c-.5519314 0-1.0010424-.4480438-1.0010424-.9999962 0-.5519314.449111-.9996405 1.0010424-.9996405s1.0010424.4477091 1.0010424.9996405c0 .5519524-.449111.9999962-1.0010424.9999962zm1.0010424-3.9996491c0 .5519524-.449111.9999962-1.0010424.9999962s-1.0010424-.4480438-1.0010424-.9999962v-4.9993095c0-.5519309.449111-.9999957 1.0010424-.9999957s1.0010424.4480648 1.0010424.9999957z" fill="#f4c300"></path>
		</svg>
    );
}

export default WarningIcon;
